import { jsx as a, Fragment as m } from "react/jsx-runtime";
import p, { isValidElement as L } from "react";
import { BodyText as u } from "./index.es505.js";
const g = (e) => typeof e == "string", f = (e, r) => {
  if (g(e))
    return h(e, r);
  if (L(e)) {
    const o = e.props.children ? p.Children.map(
      e.props.children,
      (t) => f(t, r)
    ) : e.props.children;
    return p.cloneElement(e, {
      ...e.props,
      children: o
    });
  }
  return e;
}, h = (e, r) => {
  if (!e || !r)
    return e;
  const o = r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), t = e.split(new RegExp(`(${o})`, "gi"));
  return /* @__PURE__ */ a(m, { children: t.map(
    (i, n) => i.toLowerCase() === r.toLowerCase() ? /* @__PURE__ */ a(p.Fragment, { children: /* @__PURE__ */ a(u, { isEllipsis: !0, size: "default", variant: "bold", children: i }) }, n) : /* @__PURE__ */ a(u, { isEllipsis: !0, size: "default", variant: "regular", children: i }, n)
  ) });
}, w = (e) => {
  const { searchTerm: r = "", items: o, shouldFilter: t, onItemsFiltered: i } = e, n = r == null ? void 0 : r.trim();
  let l = o;
  return t && r && (l = l.filter((s) => {
    const c = typeof s.label == "string" ? s.label : "", d = typeof s.description == "string" ? s.description : "";
    return !s.isDisabled && (c.toLocaleLowerCase().includes(n.toLocaleLowerCase()) || d.toLocaleLowerCase().includes(n.toLocaleLowerCase()));
  })), i == null || i(l), l;
}, E = (e) => {
  const { searchTerm: r = "", items: o, onItemsFiltered: t } = e, i = r == null ? void 0 : r.trim();
  if (i === "")
    return t == null || t(o), o;
  const l = w(e).map((s) => {
    if (!s.isDisabled) {
      const c = {
        ...s,
        label: f(s.label, i.toLocaleLowerCase())
      };
      return s.description ? {
        ...c,
        description: f(
          s.description,
          i.toLocaleLowerCase()
        )
      } : c;
    }
    return s;
  });
  return t == null || t(l), l;
};
export {
  w as filterItems,
  f as highlightReactNode,
  h as highlightText,
  E as highlightTextWithinItems
};
//# sourceMappingURL=index.es549.js.map
